import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Database2Icon } from '@root/shared/ui-kit'

export const SetupOtpHeading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <Icon>
        <Database2Icon size={18} />
      </Icon>
      <Title>{t('mfa.setup_instructions')}</Title>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  place-items: center;
  justify-items: center;

  &::after {
    content: '';

    height: 1px;
    width: 100%;
    margin: 16px 0;

    opacity: 0.05;
    background: radial-gradient(
      50% 50% at 50% 50%,
      var(--text-12) 0%,
      var(--text-12) 80%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`

const Icon = styled.div`
  background: var(--backgroundA-4);
  border-radius: 100%;

  display: grid;

  width: 38px;
  height: 38px;
  flex-shrink: 0;
  place-content: center;
`

const Title = styled.div`
  color: var(--text-12);

  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;

  margin-top: 10px;
`
